import { render, staticRenderFns } from "./TrainingHomeFolders.vue?vue&type=template&id=65c1eaa9&scoped=true&"
import script from "./TrainingHomeFolders.vue?vue&type=script&lang=js&"
export * from "./TrainingHomeFolders.vue?vue&type=script&lang=js&"
import style0 from "./TrainingHomeFolders.vue?vue&type=style&index=0&id=65c1eaa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c1eaa9",
  null
  
)

export default component.exports